import React, { createContext, useContext, useState, useEffect } from 'react';

const BannerContext = createContext();

export const BannerProvider = ({ children }) => {
  const [isBannerVisible, setIsBannerVisible] = useState(true);
  const [bannerHeight, setBannerHeight] = useState(0);

  const showBanner = () => setIsBannerVisible(true);
  const hideBanner = () => {
    setIsBannerVisible(false);
    setBannerHeight(0);
  };
  const updateBannerHeight = (height) => setBannerHeight(height);

  // Sync a CSS custom property so every layout/component can use var(--soc2-banner-height)
  useEffect(() => {
    const h = isBannerVisible ? bannerHeight : 0;
    document.documentElement.style.setProperty('--soc2-banner-height', `${h}px`);
  }, [isBannerVisible, bannerHeight]);

  return (
    <BannerContext.Provider value={{ isBannerVisible, bannerHeight, showBanner, hideBanner, updateBannerHeight }}>
      {children}
    </BannerContext.Provider>
  );
};

export const useBanner = () => useContext(BannerContext);